<template>
  <div>
    <popup-add-meeting-instance ref="popupAddMeetingInstance" />
    <vs-row vs-justify="space-between">
      <vs-col vs-w="6">
        <p>
          Meetings guides the participants through a series of graphs and visuals, where the participants can answer questions. A summary is
          generated when completing a meeting and is sent to chosen recipients.
        </p>
      </vs-col>
      <div>
        <vs-row>
          <vs-button
            ref="createButton"
            id="create-button"
            class="vs-con-loading__container"
            @click="onClickCreateNew"
            type="relief"
            vslor="primary"
            v-if="hasPermissionForActiveVenue('vp.vp.meetings.edit')"
            >Create meeting</vs-button
          >
        </vs-row>
      </div>
    </vs-row>

    <Loading v-if="isLoading" />
    <!-- table -->
    <div v-else class="data-list-list-view">
      <vs-table
        ref="table"
        class="mt-8"
        v-model="selected"
        pagination
        maxItems="10"
        search
        :data="mappedMeetingInstances"
        @selected="onClicked(selected.id)"
      >
        <template slot="header">
          <div class="flex mb-2">
            <vs-select label="Repeat frequency type" v-model="filters.frequencyType" class="w-full">
              <vs-select-item :value="null" text="All types" />
              <vs-select-item
                :key="frequencyType"
                v-for="frequencyType in meetingFrequencyTypes"
                :value="frequencyType"
                :text="frequencyType"
              />
            </vs-select>
          </div>
          <vs-spacer />
        </template>

        <template slot="thead">
          <vs-th sort-key="title">Title</vs-th>
          <vs-th sort-key="meeting.type">Type</vs-th>
          <vs-th sort-key="whenTimestamp">When</vs-th>
          <vs-th sort-key="facilitator">Facilitator</vs-th>
          <vs-th sort-key="isEditable">Completed</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <div class="product-name font-medium truncate flex flex-row items-center">
                  <p class="ml-4">
                    {{ tr.meeting.title }}
                  </p>
                </div>
              </vs-td>
              <vs-td>
                {{ tr.meeting.type }}
              </vs-td>
              <vs-td>
                <vs-chip class="product-order-status">
                  {{ tr.isStarted ? tr.whenMapped : "Not started" }}
                </vs-chip>
              </vs-td>
              <vs-td>
                <div class="product-name">
                  {{ tr.facilitator ? tr.facilitator.displayName : "" }}
                </div>
              </vs-td>
              <vs-td>
                <vs-button
                  v-if="tr.isEditable"
                  radius
                  color="danger"
                  size="small"
                  type="filled"
                  icon="close"
                  class="pointer-events-none"
                ></vs-button>
                <vs-button v-else radius color="green" size="small" type="filled" icon="check" class="pointer-events-none"></vs-button>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";

import PopupAddMeetingInstance from "./Components/PopupAddMeetingInstance.vue";

export default {
  components: {
    PopupAddMeetingInstance
  },
  props: [],
  data() {
    return {
      selected: null,

      filters: {
        frequencyType: null
      }
    };
  },
  methods: {
    onClicked(id) {
      this.$router
        .push({
          name: "vp-meeting",
          params: {
            id
          }
        })
        .catch(e => {});
    },
    async onClickCreateNew() {
      this.$refs.popupAddMeetingInstance.show();
    }
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      meetingInstances: "meetingInstances/all",
      isLoading: "meetingInstances/isLoading",
      meetingFrequencyTypes: "meetings/meetingFrequencyTypes"
    }),
    mappedMeetingInstances() {
      const result = this.meetingInstances
        .filter(e => {
          if (this.filters.frequencyType) {
            return e.meeting.type === this.filters.frequencyType;
          }
          return true;
        })
        .map(e => {
          let whenTimestamp = null;

          switch (e.meeting.type) {
            case "BiWeekly":
            case "Weekly":
              whenTimestamp = moment().day("Monday").week(e.when).year(e.whenYear);
              break;
            case "Monthly":
              whenTimestamp = moment().month(e.when).year(e.whenYear);
              break;
            case "Quarterly":
              whenTimestamp = moment().quarter(e.when).year(e.whenYear);
              break;
            case "BiAnnually":
            case "Annually":
              whenTimestamp = moment().year(e.whenYear);
              break;
          }

          if (!e.isStarted) {
            whenTimestamp = moment().year(2000); // Old year
          }
          const whenString = this.$store.getters["meetingInstances/whenString"](e);
          return { ...e, whenMapped: whenString, whenTimestamp };
        });

      result.sort((a, b) => {
        if (a.whenTimestamp.isBefore(b.whenTimestamp)) {
          return 1;
        }
        if (a.whenTimestamp.isAfter(b.whenTimestamp)) {
          return -1;
        }
        return 0;
      });

      return result;
    },
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    }
  },

  async created() {
    await this.$store.dispatch("meetingInstances/getForVenue", this.activeVenue.venueId);
  }
};
</script>

<style lang="scss">
.status-category {
  display: flex;
  align-items: center;
}

.status-circle {
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  margin-right: 5px;
}
</style>
